export interface CelebratoryModalContent {
	imageUrl: string;
	title: string;
	message: string;
	ctaText: string;
}

export interface RewardMessagesModalContent {
	voucherEarnedContent: CelebratoryModalContent;
	voucherSavedContent: CelebratoryModalContent;
	saveForOccasionUnlockContent: CelebratoryModalContent;
	airNzBurnContent: CelebratoryModalContent;
	qantasBurnContent: CelebratoryModalContent;
}

export const rewardMessagesModalContent: RewardMessagesModalContent = {
	voucherEarnedContent: {
		imageUrl: '/assets/images/everyday-rewards/rewards-rocket.svg',
		title: 'Nice! You earned a \n ${{voucherDollars}} voucher.',
		message: 'Save on a future shop at any partner location where your vouchers are redeemable.',
		ctaText: 'Close',
	},
	voucherSavedContent: {
		imageUrl: '/assets/images/everyday-rewards/rewards-rocket.svg',
		title: 'Nice! You saved a ${{voucherDollars}} voucher.',
		message:
			'Your current Rewards choice is set to Save for an occasion.  This voucher will be ready to spend from <b>{{voucherUnlockDate}}</b>.  Change your date or your Rewards choice at any time.',
		ctaText: 'Close',
	},
	saveForOccasionUnlockContent: {
		imageUrl: '/assets/images/everyday-rewards/rewards-rocket.svg',
		title: 'Nice! You can spend your ${{voucherDollars}} vouchers for your occasion.',
		message:
			'Your Everyday Rewards vouchers are now ready to spend, and your Rewards choice has been updated to Everyday Rewards vouchers. You can switch to another Rewards choice in your Account settings.',
		ctaText: 'Close',
	},
	airNzBurnContent: {
		imageUrl: 'assets/images/everyday-rewards/rewards-air-new-zealand.svg',
		title: 'Nice! Your Everyday Rewards points have been converted to {{airpointsDollars}} Airpoints&nbsp;Dollars™.',
		message: "We've transferred your Airpoints&nbsp;Dollars™ to your Airpoints™ account.",
		ctaText: 'Close',
	},
	qantasBurnContent: {
		imageUrl: 'assets/images/everyday-rewards/rewards-qantas.svg',
		title: 'Nice! Your Everyday Rewards points have been converted to {{qantasPoints}} Qantas Points.',
		message: "We've transferred your Qantas Points to your Qantas Frequent Flyer account.",
		ctaText: 'Close',
	},
};
